import { render, staticRenderFns } from "./RenyuanAdd.vue?vue&type=template&id=2b1714cc&scoped=true"
import script from "./RenyuanAdd.vue?vue&type=script&lang=js"
export * from "./RenyuanAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1714cc",
  null
  
)

export default component.exports